import React from 'react';
import Card from './Card';
import {
  Form,
  ControlLabel,
  FormControl,
  FormGroup,
  Col,
} from 'react-bootstrap';

export const InfoCard = props => {
  return (
    <Card>
      <Form horizontal>
        {props.fields.map(field => (
          <FormGroup key={field.id}>
            <Col componentClass={ControlLabel} sm={2}>{field.label}</Col>
            <Col sm={10}>
              <FormControl.Static>{field.value}</FormControl.Static>
            </Col>
          </FormGroup>
        ))}
      </Form>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/components/card/InfoCard.js